import kebabCase from 'lodash/kebabCase';
import validator from 'validator';

import { sampleAgentNames } from './constants';

export const isValidURL = (urlString: string): boolean => {
  return validator.isURL(urlString);
};

function urlWithProtocol(inputUrl: string): string {
  let url = inputUrl;
  if (!/^https?:\/\//i.test(url)) {
    url = `https://${url}`;
  }
  return url;
}

export const extractDomain = (urlString: string): string => {
  try {
    const domain = new URL(urlWithProtocol(urlString));
    return domain.hostname;
  } catch (error) {
    return '';
  }
};

export const randomAgentName = () => {
  const randomIndex = Math.floor(Math.random() * sampleAgentNames.length);
  return sampleAgentNames[randomIndex];
};

const pad2 = (value: number): string => String(value).padStart(2, '0');

// [agent-name]-kb-[YYYY-MM-DD-HHMM].csv, falling back to the legacy
// 'knowledge-base.csv' when there's no name to slugify.
export const buildKnowledgeBaseExportFilename = (
  agentName: string,
  date: Date = new Date(),
): string => {
  const slug = kebabCase(agentName);
  if (!slug) return 'knowledge-base.csv';
  const timestamp = `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(
    date.getDate(),
  )}-${pad2(date.getHours())}${pad2(date.getMinutes())}`;
  return `${slug}-kb-${timestamp}.csv`;
};
